import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20manga%20comic%20background%20with%20warm%20coral%20orange%20and%20golden%20amber%20gradients%2C%20soft%20flowing%20lines%20like%20comic%20panels%2C%20dreamy%20atmospheric%20style%2C%20no%20text%2C%20clean%20composition%2C%20warm%20inviting%20tones&width=1600&height=900&seq=hero-bg-pudding&orientation=landscape"
          alt="布丁漫画网 - 沉浸式漫画阅读体验"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
          布丁漫画 · 下拉式连续阅读
        </h1>
        <p className="text-white/90 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          布丁漫画网提供<strong>布丁漫画全集下拉式连续阅读</strong>，无需翻页即可畅享完整漫画内容。
          布丁漫画下拉式免费看<strong>韩漫、日漫、国漫</strong>大全，追更最新全集更新。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/hanman"
            className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即免费阅读
            <span className="ml-2"><i className="ri-arrow-right-line"></i></span>
          </Link>
          <Link
            to="/#featured"
            className="bg-white/20 hover:bg-white/30 text-white border border-white/30 px-8 py-3 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            热门推荐
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10">
          {[
            { value: '10,000+', label: '漫画资源' },
            { value: '500万+', label: '月活用户' },
            { value: '99.9%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-white font-heading text-xl md:text-2xl font-bold">{stat.value}</p>
              <p className="text-white/70 text-xs mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}